import { CORS } from 'root/utils/cors/cors';
import { CookieMonster } from 'root/utils/cookies/cookieMonster';

export default function LightboxLoader(name) {
    this.ENDPOINT = '/rest/forms/load/lightbox';
    this.METHOD = 'GET';
    this.name = name;
    this.data = '';
    this.successClb = null;
    this.errorClb = null;
    this.response = null;
    this.cm = new CookieMonster();
}
LightboxLoader.prototype = {
    getFile() {
        const data = this.getParam();
        CORS.xdr(
            this.ENDPOINT + data,
            this.METHOD,
            '',
            this.successClb,
            this.errorClb,
            false
        );
        return this;
    },

    /**
     * Overrides the default function
     * @param callable callback
     */
    onSuccess(callback) {
        this.successClb = callback;
        return this;
    },

    /**
     * Overrides the default function
     * @param callable callback
     */
    onError(callback) {
        this.errorClb = callback;
        return this;
    },

    getResponse() {
        return this.response;
    },

    getParam() {
        return `?name=${this.name}&country=${
            this.cm.getCookie('geoConfig')?.country_code.toLowerCase() ?? 'us'
        }`;
    },
};
